import { event } from '@marine/lib';
import { message } from 'antd';
import { eventNames } from 'mdc-constants';
import { useCallback, useMemo, useState } from 'react';
import { GetFilesDataItem } from 'services';
import { useUploadFileMutation } from 'services/hooks/mutations';

export const useFileUploadHandler = ({
  folderId,
  updateFilesCacheAfterUpload,
  selectNewUploadedItem,
}: {
  folderId: string | undefined;
  updateFilesCacheAfterUpload: any;
  selectNewUploadedItem: (newItem: GetFilesDataItem) => void;
}) => {
  const [isUploadingFile, setIsUploadingFile] = useState<boolean>(false);
  const formData = useMemo(() => new FormData(), []);

  const { mutateAsync: uploadFile } = useUploadFileMutation({ formData });

  const handleUpload = useCallback(
    (file: File) => {
      formData.append('file', file);

      if (folderId) {
        formData.append('folder_id', folderId as string);
      }
      setIsUploadingFile(true);

      uploadFile()
        .then((response: any) => {
          setIsUploadingFile(false);
          updateFilesCacheAfterUpload(response);
          selectNewUploadedItem(response);
          message.success('File uploaded successfully.');
          // File delete event
          event({
            action: eventNames.fileUpload,
            category: eventNames.fileEventCategory,
            label: eventNames.fileUploadLabel,
          });
        })
        .catch(() => {
          setIsUploadingFile(false);
          message.error('File could not upload!');
        });
    },
    [folderId, updateFilesCacheAfterUpload, selectNewUploadedItem, formData, uploadFile],
  );

  return {
    handleUpload,
    isUploadingFile,
  };
};
